module.exports = __webpack_public_path__ + "static/media/ye.c36d15c3.mp3";